import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

async function parseError(res, fallback) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || fallback);
}

export async function fetchOperatorCameras() {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/cameras`);
    if (!res.ok) await parseError(res, "Не вдалося завантажити камери");
    return res.json();
}

export async function createOperatorCamera(payload) {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/cameras`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) await parseError(res, "Не вдалося створити камеру");
    return res.json();
}

export async function updateOperatorCamera(cameraId, payload) {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/cameras/${encodeURIComponent(cameraId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) await parseError(res, "Не вдалося оновити камеру");
    return res.json();
}

export async function fetchOperatorCameraRecordings(cameraId, limit = 120) {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/cameras/${encodeURIComponent(cameraId)}/recordings?limit=${encodeURIComponent(limit)}`);
    if (!res.ok) await parseError(res, "Не вдалося завантажити записи");
    return res.json();
}

export async function fetchLocationCameraPermissions(locationId) {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/location-permissions?location_id=${encodeURIComponent(locationId)}`);
    if (!res.ok) await parseError(res, "Не вдалося завантажити доступи до історії");
    return res.json();
}

export async function saveLocationCameraPermissions(items) {
    const res = await apiFetch(`${API_BASE}/camera-access/operator/location-permissions`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
    });
    if (!res.ok) await parseError(res, "Не вдалося зберегти доступи до історії");
    return res.json();
}

export function buildOperatorRecordingUrl(downloadUrl) {
    if (!downloadUrl) return "";
    if (/^https?:\/\//i.test(downloadUrl)) return downloadUrl;
    return `${API_BASE}${downloadUrl}`;
}